module.exports = __webpack_public_path__ + "media/referral/desktop_banner-ff32eefe.png";